import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { useGetFormDataWithSpaceId } from '../useGetFormDataWithSpaceId'
import type {
  Error,
  GetRequirementsSaveResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (response: GetRequirementsSaveResponse) => ReactElement
  onSuccess?: (response: GetRequirementsSaveResponse) => void
  onError?: (error: Error) => void
  spinnerSize?: number
  formData?: FormData
}

const SaveRequirementsRequest = ({
  children,
  onSuccess,
  onError,
  spinnerSize,
  formData
}: Props) => {
  const url = `${MODELER_SERVICE}/requirements`

  const { requestParams } = useGetFormDataWithSpaceId(formData)

  return (
    <AuthenticatedDataRequest
      children={children}
      formData={requestParams}
      isUrlEncoded
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      spinnerSize={spinnerSize}
      url={url}
    />
  )
}

export default SaveRequirementsRequest
